<div class="main-frame d-flex justify-content-center justify-content-md-start">
  <div style=" margin: 4vh 4vh 0vh 4vh; height: 20vh;">
      <div class="icon-plus mat-elevation-z4" (click)='newCompania()'>
          <mat-icon class="fa plus">plus</mat-icon>
      </div>
      <div class="icon-title">
          <h2>Agregar compañia</h2>
      </div>
  </div>
  <div style="padding: 4vh 4vh 0 4vh;" *ngFor="let compania of companias; index as index">
          <div
              class="img-background icon mat-elevation-z4"
              [ngStyle]="{ 'background-image': 'url(' + baseUrl + compania.logo + '/0' + ')'}"
              (click)="handleClick(index)"
              [ngSwitch]="compania.state">
          <div>
              <div *ngSwitchCase="0" class = "led-red"></div>
              <div *ngSwitchCase="1" class = "led-green"></div>
          </div>
      </div>
      <div class="icon-title">
          <h3>{{ compania.name | slice: 0: 21 }}{{ compania.name.length > 21 ? '...' : ''}}</h3>
      </div>
  </div>
</div>
